export const asmCustomer360 = {
  asmCustomer360: {
    alertErrorMessage:
      'La información no se puede cargar. Inténtelo de nuevo más tarde o contacte con su administrador del sistema.',
    errorMessageHeader: '¡Vaya! Algo salió mal',
    applyActionAlter:
      'No se pudo completar la acción. Inténtelo de nuevo más tarde.',
    header: {
      newTitle: "Cliente 360°",
      title: 'Perfil del cliente',
      subTitle: '{{name}} Vista 360° del cliente',
      activeCartLabel: '{{cartSize}} productos añadidos al carrito',
      recentOrderLabel: 'Último pedido {{price}}',
      recentTicketLabel: 'Último ticket',
      signedUpAt: 'Cuenta creada el {{date}}',
    },
    productListing: {
      totalNoItems: 'Total de artículos {{count}}',
      totalPrice: 'Precio total {{price}}',
      showMore: 'Mostrar más',
      showLess: 'Mostrar menos',
    },
    productItem: {
      outOfStock: 'Agotado',
      quantity: 'Cantidad: {{count}}',
      itemPrice: 'Precio del artículo: {{price}}',
    },
    activeCart: {
      header: 'Carrito activo',
      emptyDescription: 'En este momento no hay productos activos en su carrito.',
      aria: {
        linkLabel: 'Carrito activo {{code}}',
      },
    },
    savedCart: {
      header: 'Último carrito guardado',
      emptyDescription: 'En este momento no hay productos guardados en su carrito.',
      aria: {
        linkLabel: 'Último carrito guardado {{code}}',
      },
    },
    productInterests: {
      header: 'Intereses',
      emptyDescription: 'Actualmente no hay elementos de interés',
    },
    profile: {
      address: 'Dirección',
      billingAddress: 'Dirección de facturación',
      deliveryAddress: 'Dirección de entrega',
      phone1: 'Teléfono 1',
      phone2: 'Teléfono 2',
      paymentMethodHeader: 'Métodos de pago guardados',
    },
    activity: {
      type: 'Tipo',
      id: 'ID',
      description: 'Descripción',
      status: 'Estado',
      created: 'Creados',
      updated: 'Actualizados',
      numberOfCartItems: 'Carrito con {{count}} productos',
      cart: 'Carrito',
      order: 'Pedido',
      savedCart: 'Carrito guardado',
      emptyStateText: 'Actualmente no hay actividad registrada del cliente',
      headerText: 'General',
    },
    productReviews: {
      columnHeaders: {
        item: 'Elemento',
        dateAndStatus: 'Fecha / Estado',
        rating: 'Clasificación',
        review: 'Revisión',
      },
      header: 'Revisiones del producto',
      emptyDescription: 'Actualmente no hay revisiones de productos',
      sku: 'SKU',
    },
    supportTickets: {
      columnHeaders: {
        id: 'ID',
        headline: 'Título',
        category: 'Categoría',
      },
      header: 'Tickets de soporte',
      emptyDescription: 'En este momento no hay tickets de soporte',
    },
    coupons: {
      headerText: 'Cupones',
      emptyDescription: 'Actualmente no hay cupones',
      applyButtonText: 'Aplicar al carrito',
      applied: 'Cupón aplicado',
      removeButtonText: 'Eliminar',
    },
    promotions: {
      headerText: 'Promociones',
      emptyDescription: 'Actualmente no hay promociones',
      applied: 'Promoción aplicada',
      headerName: 'Nombre',
      headerAction: 'Acción',
    },
    customerCoupons: {
      headerText: 'Cupones del cliente',
      emptyDescription: 'Actualmente no hay cupones del cliente',
      applyButtonText: 'Asignar al cliente',
      removeButtonText: 'Eliminar',
      availableTab: 'Disponibles',
      sentTab: 'Enviados',
      searchBox: 'Cupón',
    },
    maps: {
      storeClosed: 'Cerrado',
      storesFound: '{{ initial }} - {{ end }} de {{ total }} tiendas encontradas',
    },
    overviewTab: 'Resumen',
    profileTab: 'Perfil',
    activityTab: 'Actividad',
    feedbackTab: 'Comentarios',
    promotionsTab: 'Promociones',
    mapsTab: 'Mapas',
    storeLocationsTab: 'Mapas',
    aria: {
      activeCartCode: 'Carrito activo {{code}}',
      recentOrderCode: 'Último pedido {{code}}',
    },
    pagination: 'Paginación',
    page: 'Página {{number}}',
    emptyCellValue: '---',
  },
};
